<template>
  <div id="add-new-order-modal">
    <v-layout row justify-center>
      <v-dialog v-model="editCouponModal" persistent max-width="340px">
        <v-card>
          <form action="" @submit.prevent="submitForm()">
            <v-card-title>
              <v-flex xs11 sm11 md11><span class="headline">{{ $t('giveToCustomer.title') }}</span></v-flex>
              <v-flex xs1 sm1 md1>
                <v-btn flat @click="closeEditCouponModal(), $validator.reset()" class="close"
                  ><span aria-hidden="true">
              <i class="material-icons" style="font-size: 24px;vertical-align: middle;">close</i>
            </span></v-btn
                >
              </v-flex>
            </v-card-title>
            <v-card-text>
              <v-alert type="success" :value="checkAlert">
                {{ $t('generateCoupon.couponsUpdatedSuccessfully') }}
              </v-alert>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm12 md3>
                    <v-text-field
                      :label="$t('generateCoupon.discountPercentageLabel') + '*'"
                      v-model="editData.percentage"
                      :error-messages="errors.collect('Discount percentage')"
                      v-validate="'required|decimal:2'"
                      data-vv-name="Discount percentage"
                    >
                    </v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                style="height:auto"
                @click="closeEditCouponModal(), $validator.reset()"
                outline
                color="normal"
                >{{ $t('common.cancel') }}</v-btn
              >
              <v-btn type="submit" style="height:auto" class="rtl-mr-6pct" outline color="success"
                >{{ $t('common.update') }}</v-btn
              >
            </v-card-actions>
          </form>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>
<script>
export default {
  props: ['editCouponModal', 'closeEditCouponModal', 'checkAlert', 'editData', 'editCoupon'],

  methods: {
    submitForm() {
      this.$validator.validateAll().then(res => {
        if (res) {
          this.editCoupon()
        }
      })
    }
  }
}
</script>

<style>
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/coupons/editCoupon.vue